//product-card image slider (móvil + desktop, con hover a la segunda imagen)
(function () {
  // Inject CSS once (so repeating the snippet doesn't duplicate styles)
  if (!document.getElementById('pcms-styles')) {
    var css = '\
.product-card__slider-wrapper{width:100%}\
.product-card__slider{display:flex;width:100%;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;gap:.5rem;-ms-overflow-style:none;scrollbar-width:none;cursor:grab}\
.product-card__slider.is-dragging{cursor:grabbing;scroll-snap-type:none}\
.product-card__slider::-webkit-scrollbar{display:none}\
.product-card__slide{flex:0 0 100%;scroll-snap-align:start;min-width:100%;box-sizing:border-box;position:relative}\
.product-card__slide img{width:100%;max-width:100%;display:block}\
.product-card__slider-wrapper{position:relative}\
.product-card__slider-dots{position:absolute;bottom:.625rem;left:.75rem;right:.75rem;z-index:2;display:flex;justify-content:center;gap:.3rem;margin:0;padding:0;pointer-events:auto}\
.slider-dot{width:4px;height:4px;background:#ccc;border-radius:50%;transition:background .25s ease;border:0;padding:0;margin:0;cursor:pointer}\
.slider-dot.active{background:#000}';
    var style = document.createElement('style');
    style.id = 'pcms-styles';
    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  // Solo hay hover real en dispositivos con ratón
  var hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');

  function initSlider(slider) {
    if (slider.dataset.pcmsInit) return;
    slider.dataset.pcmsInit = '1';

    var slides = slider.querySelectorAll('.product-card__slide');
    var wrapper = slider.closest('.product-card__slider-wrapper') || slider.parentElement;
    var dotsContainer = wrapper ? wrapper.querySelector('.product-card__slider-dots') : null;

    if (!dotsContainer || slides.length <= 1) {
      if (dotsContainer) dotsContainer.style.display = 'none';
      return;
    }

    function closestIndex() {
      var scrollLeft = slider.scrollLeft;
      var index = 0;
      var minDiff = Infinity;
      slides.forEach(function (s, i) {
        var diff = Math.abs(scrollLeft - s.offsetLeft);
        if (diff < minDiff) { minDiff = diff; index = i; }
      });
      return index;
    }

    function goTo(i) {
      slider.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }

    // ── Estado compartido entre drag y hover ────────────────────────────────
    var isDown = false;
    var isDragging = false;
    var startX = null;
    var startY = null;
    var startScroll = 0;
    var usingMouse = false;
    var indexBeforeHover = null;
    var userTookControl = false;

    // ── Puntos de navegación ────────────────────────────────────────────────
    if (!dotsContainer.dataset.inited) {
      slides.forEach(function (_, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'slider-dot' + (i === 0 ? ' active' : '');
        btn.setAttribute('aria-label', 'Ver imagen ' + (i + 1) + ' de ' + slides.length);
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          userTookControl = true;
          goTo(i);
        });
        dotsContainer.appendChild(btn);
      });
      dotsContainer.dataset.inited = '1';
    }

    // ── Punto activo al hacer scroll ────────────────────────────────────────
    var ticking = false;
    slider.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var current = closestIndex();
        dotsContainer.querySelectorAll('.slider-dot').forEach(function (d, i) {
          d.classList.toggle('active', i === current);
        });
        ticking = false;
      });
    }, { passive: true });

    // ── Hover: salta a la segunda imagen y vuelve al salir ──────────────────
    wrapper.addEventListener('pointerenter', function (e) {
      if (!hoverMedia.matches || e.pointerType === 'touch') return;
      if (isDown) return;
      indexBeforeHover = closestIndex();
      userTookControl = false;
      if (indexBeforeHover === 0) {
        goTo(1);
      }
    });

    wrapper.addEventListener('pointerleave', function (e) {
      if (!hoverMedia.matches || e.pointerType === 'touch') return;
      if (indexBeforeHover === null) return;
      // Si el usuario ha arrastrado o pulsado un punto, respetamos donde lo dejó
      if (!userTookControl) {
        goTo(indexBeforeHover);
      }
      indexBeforeHover = null;
    });

    // ── Arrastre con ratón / deslizamiento táctil ───────────────────────────
    slider.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      isDown = true;
      isDragging = false;
      usingMouse = e.pointerType === 'mouse';
      startX = e.clientX;
      startY = e.clientY;
      startScroll = slider.scrollLeft;
      try { slider.setPointerCapture && slider.setPointerCapture(e.pointerId); } catch (er) {}
    });

    slider.addEventListener('pointermove', function (e) {
      if (!isDown || startX === null) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (!isDragging && Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) {
        isDragging = true;
        userTookControl = true;
        if (usingMouse) slider.classList.add('is-dragging');
      }
      // El arrastre con ratón hay que moverlo a mano; el táctil lo hace el navegador
      if (isDragging && usingMouse) {
        e.preventDefault();
        slider.scrollLeft = startScroll - dx;
      }
    });

    function endDrag(e) {
      if (!isDown) return;
      isDown = false;
      startX = null;
      startY = null;
      if (usingMouse && isDragging) {
        slider.classList.remove('is-dragging');
        goTo(closestIndex());
      }
      setTimeout(function () { isDragging = false; }, 50);
      try { if (e && slider.releasePointerCapture) slider.releasePointerCapture(e.pointerId); } catch (er) {}
    }

    slider.addEventListener('pointerup', endDrag);
    slider.addEventListener('pointercancel', endDrag);

    // Si el usuario arrastra, cancelamos el clic que navegaría al producto
    slider.addEventListener('click', function (e) {
      if (isDragging) {
        e.preventDefault(); e.stopImmediatePropagation(); return false;
      }
    }, true);
  }

  function initAll() {
    document.querySelectorAll('.product-card__slider').forEach(initSlider);
  }

  if (!window.__productCardMobileSlider) window.__productCardMobileSlider = {};
  window.__productCardMobileSlider.initAll = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

// =============================
// PRODUCT CARD SLIDER INIT
// =============================
(function () {
  function activateSliders() {
    document.querySelectorAll('.js-product-card-image-container').forEach(function (container) {
      if (container.dataset.sliderActivated === "true") return;

      var card = container.closest('.product-card');
      var template = card && card.querySelector('template[data-mobile-slider-template]');
      if (!template) return;

      container.innerHTML = template.innerHTML;
      container.dataset.sliderActivated = "true";
    });

    if (window.__productCardMobileSlider && window.__productCardMobileSlider.initAll) {
      window.__productCardMobileSlider.initAll();
    }
  }

  // Reprocesa cuando se inyectan tarjetas nuevas (paginación AJAX, filtros, orden)
  var pending = false;
  function scheduleActivate() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      activateSliders();
    });
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        scheduleActivate();
        return;
      }
    }
  });

  function startObserving() {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      activateSliders();
      startObserving();
    });
  } else {
    activateSliders();
    startObserving();
  }

  document.addEventListener('shopify:section:load', scheduleActivate);
  document.addEventListener('shopify:section:reorder', scheduleActivate);
})();